import React from 'react'
import styled from 'styled-components'
import { ISelectedProblem } from '../DriversMain'
import ImageComponentHead from '../../../../../generic/imageComponents/ImageComponentHead'
import Image from '../../../../../generic/assets/delivery.png'
import ProblemProductCard from './ProblemProductCard'
import Disclaimer from '../../teudotProblems/Components/Disclaimer'
type Props = {
  handleProblem: (problemID: number, status: number) => void
  selectedProblem: ISelectedProblem
}

const ProblemHandleModal = ({
  handleProblem,
  selectedProblem
}: Props) => {
  const handleApproveProblem = (problemID: number) => {
    handleProblem(problemID, 1)
  }

  const handleRejectProblem = (problemID: number) => {
    handleProblem(problemID, 2)
  }
 console.log('selectedProblem', selectedProblem)
  return (
    <MainWrapper>
      <ImageContainer>
        <ImageComponentHead
          img={Image}
          large
        />
      </ImageContainer>
      <DisclaimerContainer>
        <Disclaimer>
          ימינה או שמאלה לאישור איסוף
        </Disclaimer>
      </DisclaimerContainer>
      <BodyWrapper>
        <ProductsList>
          {selectedProblem.item.map((product, index) => (
            <ProblemProductCard
              key={`${product.ProductID}-${product.OrderID}-${index}`}
              product={product}
              index={index}
              onApprove={handleApproveProblem}
              onReject={handleRejectProblem}
            />
          ))}
        </ProductsList>
      </BodyWrapper>
    </MainWrapper>
  )
}

const MainWrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const ImageContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
`
const DisclaimerContainer = styled.div`
  width: 80%;
  flex-shrink: 0;
`
const BodyWrapper = styled.div`
  width: 90%;
  flex: 1;
  min-height: 0;
  padding: 1em;
  border-radius: 1em;
  display: flex;
  flex-direction: column;
  gap: 1.5em;
`

const ProductsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(233, 240, 240, 0.1);
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(41, 127, 118, 0.3);
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(41, 127, 118, 0.5);
  }
`

export default ProblemHandleModal